import { c as _c } from "react/compiler-runtime";
import { cicToType, getTimeAgoShort } from "@/helpers/Helpers";
import { assertUnreachable } from "@/helpers/AllowlistToolHelpers";
import DropAuthorHandle from "./DropAuthorHandle";
import UserCICAndLevel, { UserCICAndLevelSize } from "@/components/user/utils/UserCICAndLevel";
import { DropPartSize } from "@/components/drops/view/part/DropPart.types";
import { ProfileMinWithoutSubs } from "@/helpers/ProfileTypes";
interface DropAuthorProps {
  readonly profile: ProfileMinWithoutSubs;
  readonly timestamp: number;
  readonly size?: DropPartSize;
  readonly children?: React.ReactNode;
}
export default function DropAuthor(t0) {
  const $ = _c(24);
  const {
    profile,
    timestamp,
    size: t1,
    children
  } = t0;
  const size = t1 === undefined ? DropPartSize.MEDIUM : t1;
  let t2;
  if ($[0] !== profile.cic) {
    t2 = cicToType(profile.cic);
    $[0] = profile.cic;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const cicType = t2;
  let t3;
  if ($[2] !== size) {
    t3 = () => {
      switch (size) {
        case DropPartSize.SMALL:
          {
            return "tw-text-sm";
          }
        case DropPartSize.MEDIUM:
        case DropPartSize.LARGE:
          {
            return "tw-text-md";
          }
        default:
          {
            assertUnreachable(size);
            return "";
          }
      }
    };
    $[2] = size;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  const getTextClasses = t3;
  const textClasses = getTextClasses();
  let t4;
  if ($[4] !== cicType || $[5] !== profile.level) {
    t4 = <UserCICAndLevel level={profile.level} cicType={cicType} size={UserCICAndLevelSize.SMALL} />;
    $[4] = cicType;
    $[5] = profile.level;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== profile || $[8] !== size) {
    t5 = <DropAuthorHandle profile={profile} size={size} />;
    $[7] = profile;
    $[8] = size;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== t4 || $[11] !== t5) {
    t6 = <div className="tw-flex tw-items-center tw-gap-x-2 tw-text-center">{t4}{t5}</div>;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== children || $[14] !== t6) {
    t7 = <div className="tw-flex tw-items-center">{t6}{children}</div>;
    $[13] = children;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = `${textClasses} tw-mb-0 tw-whitespace-nowrap tw-font-normal tw-leading-none tw-text-iron-500`;
  let t9;
  if ($[16] !== timestamp) {
    t9 = getTimeAgoShort(timestamp);
    $[16] = timestamp;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  let t10;
  if ($[18] !== t8 || $[19] !== t9) {
    t10 = <p className={t8}>{t9}</p>;
    $[18] = t8;
    $[19] = t9;
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== t10 || $[22] !== t7) {
    t11 = <div className="tw-flex tw-items-center tw-w-full tw-gap-x-2">{t7}{t10}</div>;
    $[21] = t10;
    $[22] = t7;
    $[23] = t11;
  } else {
    t11 = $[23];
  }
  return t11;
}